import { useGetSeoPage } from "contexts/SeoContext";
import Head from "next/head";
import { useTheme } from "styled-components";
import useGetCountry from "../../hooks/useGetCountry";
import React from "react";

export default function SeoHeadWidget() {
    const { host } = useTheme();
    const seoPage = useGetSeoPage();
    const country = useGetCountry();
    const [_, twitterAccount] = country?.twitter_url?.split("twitter.com/") || [];
    if (!seoPage) return null;
    let canonical = seoPage.canonical ?? "";
    canonical =
        canonical && canonical.indexOf("http") !== 0 ? `https://${host}${canonical}` : canonical;
    return (
        <Head>
            <title>{seoPage.pageTitle}</title>
            <meta name="robots" content={seoPage.robots ?? "index,follow"} />
            {canonical && <link href={canonical} rel="canonical" key="canonical" />}
            <meta name="description" content={seoPage.pageMetaDescription} />
            <meta name="og:description" content={seoPage.pageMetaDescription} />
            <meta name="og:title" content={seoPage.pageTitle} />
            {seoPage.androidAlternate && (
                <link
                    href={seoPage.androidAlternate}
                    rel="alternate"
                    key="androidDeepLink"
                />
            )}
            {(
                seoPage.ogImages || [
                    process.env.NEXT_PUBLIC_CUSTOM_THEME === "shobiddak" ? process.env.NEXT_PUBLIC_PUBLIC_FOLDER_CDN +"/images/shobiddakLogo/shobiddak-144x144.png": "https://opensooqui2.os-cdn.com/os_web/fbApp/opensooq_fb_square.png",
                ]
            )?.map((ogImage) => {
                return <meta key={ogImage} property="og:image" content={ogImage} />;
            })}
            {seoPage?.hrefLangs?.length>1 && seoPage?.hrefLangs?.map(({ href, hreflang }) => {
                return (
                    <link
                        key={hreflang}
                        href={href}
                        rel="alternate"
                        hrefLang={hreflang}
                    />
                );
            })}
            {seoPage["schema.org"] &&
                Array.isArray(seoPage["schema.org"]) &&
                seoPage["schema.org"].map((structuredData, index) => (
                    <script
                        key={index}
                        type="application/ld+json"
                        dangerouslySetInnerHTML={{ __html: structuredData }}
                    />
                ))}
            <meta name="twitter:site" content={`@${twitterAccount}`} />
            <meta name="twitter:card" content="app" />
            <meta
                name="twitter:description"
                content="Download Opensooq app on your mobile now, sell and buy for free"
            />
            <meta name="twitter:app:name:iphone" content="Opensooq" />
            <meta name="twitter:app:id:iphone" content="654456967" />
            <meta
                name="twitter:app:url:iphone"
                content="https://itunes.apple.com/en/app/id654456967"
            />
            <meta name="twitter:app:name:ipad" content="Opensooq" />
            <meta name="twitter:app:id:ipad" content="654456967" />
            <meta
                name="twitter:app:url:ipad"
                content="https://itunes.apple.com/en/app/id654456967"
            />
            <meta name="twitter:app:name:googleplay" content="Opensooq" />
            <meta name="twitter:app:id:googleplay" content="com.opensooq.OpenSooq" />
            <meta
                name="twitter:app:url:googleplay"
                content="https://play.google.com/store/apps/details?id=com.opensooq.OpenSooq"
            />
        </Head>
    );
}
